// extracted by mini-css-extract-plugin
export default {"toggle":"ViewToggle_toggle__Vm8gM","toggleItem":"ViewToggle_toggleItem__L9MQ3","active":"ViewToggle_active__DlPMR","icon":"ViewToggle_icon__N7P95","label":"ViewToggle_label__5cz-J"};